import React, { useEffect, useRef, useState } from 'react';

import { WebRTCAdaptor } from '@antmedia/webrtc_adaptor';
import { Box, Typography } from '@mui/joy';

export interface AntMediaVideoProps {
  streamId?: string;
  websocketUrl: string;
}

const AntMediaVideo: React.FC<AntMediaVideoProps> = ({ streamId, websocketUrl }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const adaptorRef = useRef<WebRTCAdaptor | undefined>(undefined);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!streamId || !videoRef.current || initialized) return;

    adaptorRef.current = new WebRTCAdaptor({
      websocket_url: websocketUrl,
      isPlayMode: true,
      peerconnection_config: {
        iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
      },
      sdp_constraints: {
        OfferToReceiveAudio: true,
        OfferToReceiveVideo: true
      },
      remoteVideoElement: videoRef.current,
      callback: (info: string) => {
        console.log('info', info);
        if (info === 'initialized') {
          setInitialized(true);
        }
      },
      callbackError: (error: unknown) => {
        console.error('WebRTCAdaptor error', error);
      }
    });

    return () => {
      if (adaptorRef.current) {
        try {
          if (streamId) adaptorRef.current.stop(streamId);
        } catch {
          // ignore
        }
      }
    };
  }, [streamId, websocketUrl]);

  useEffect(() => {
    if (initialized && adaptorRef.current && streamId) {
      adaptorRef.current.play(streamId);
    }
  }, [initialized, streamId]);

  if (!streamId) {
    return (
      <Box className='flex items-center justify-center w-full h-full' sx={{ bgcolor: 'common.black' }}>
        <Typography level='body-md' color='neutral'>
          No video stream available
        </Typography>
      </Box>
    );
  }

  return (
    <Box className='border'>
      <video
        ref={videoRef}
        className='w-full h-full object-contain'
        controls
        autoPlay
        muted
        playsInline
        width='480'
        height='360'
      />
    </Box>
  );
};

export default AntMediaVideo;
